import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownButton, Tooltip } from '@dixa/lib-shared-habla';
import { analytics } from 'app/utils/segment';
import { ConversationHeaderPastAssignees } from './components/pastAssignees/conversationHeaderPastAssignees';
import styles from './conversationHeaderMoreMenu.module.scss';
export const ConversationHeaderMoreMenu = () => {
    return (_jsx(Tooltip, Object.assign({ dark: true, content: "View more actions" }, { children: _jsx(DropdownButton, { icon: "dots-v", buttonProps: { variant: 'tertiary' }, onToggle: (isOpen) => isOpen && analytics.conversationHeaderMoreMenuOpened(), dropdown: _jsx("div", Object.assign({ className: styles.dropdownContent }, { children: _jsx(ConversationHeaderPastAssignees, {}) })) }) })));
};
